// src/components/BlogPreview.js
import React, { useEffect, useState } from "react";
import axios from "axios";

function BlogPreview({ blogUrl }) {
  const [og, setOg] = useState(null);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios
      .get(`${baseUrl}/api/preview?url=${encodeURIComponent(blogUrl)}`)
      .then((res) => setOg(res.data))
      .catch(() =>
        setOg({ title: "불러오기 실패", description: "", image: "" })
      );
  }, [blogUrl]);

  if (!og) return <p>로딩 중...</p>;

  const proxyUrl = `${baseUrl}/api/proxy/image?url=${encodeURIComponent(
    og.image
  )}`;

  return (
    <a
      href={blogUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full max-w-xs mx-auto border rounded-md shadow-sm hover:shadow-xl p-4 transition">
      {og.image && (
        <img
          src={proxyUrl}
          alt={og.title}
          className="hidden sm:block w-full h-48 object-cover rounded"
        />
      )}

      <h3 className="font-semibold text-lg">{og.title}</h3>
      <p
        className="text-sm text-gray-600"
        dangerouslySetInnerHTML={{ __html: og.description }}
      />
      <div className="og-span mt-2 text-sm text-gray-500">{og.span}</div>
    </a>
  );
}

export default BlogPreview;
